const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

export function googleSignIn(): Promise<string> {
  return new Promise((resolve, reject) => {
    const redirectUri = `${window.location.origin}/api/integrations/google/callback`;
    const scope = 'openid email profile https://www.googleapis.com/auth/calendar.readonly';
    const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=token&scope=${encodeURIComponent(scope)}&prompt=consent`;

    const width = 500;
    const height = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const popup = window.open(
      url,
      'google-auth',
      `width=${width},height=${height},left=${left},top=${top}`
    );

    if (!popup) {
      reject(new Error('Popup blocked. Please allow popups for this site.'));
      return;
    }

    const interval = setInterval(() => {
      try {
        if (popup.closed) {
          clearInterval(interval);
          reject(new Error('Authentication cancelled'));
          return;
        }

        const popupUrl = popup.location.href;
        if (popupUrl.includes('access_token=')) {
          const hash = popupUrl.split('#')[1];
          const params = new URLSearchParams(hash);
          const accessToken = params.get('access_token');
          clearInterval(interval);
          popup.close();
          if (accessToken) {
            resolve(accessToken);
          } else {
            reject(new Error('No access token received'));
          }
        }
      } catch (e) {
        // Cross-origin — popup still on Google's domain
      }
    }, 500);
  });
}
